import { PaymentMethod } from '@40seas/entities/payment-methods';
import { PaymentMethodType } from '@40seas/models';
import Stripe from 'stripe';
import { ACSSPaymentMethod } from '../acss-payment-method.entity';

export async function acssPaymentMethodTypeHandler(stripePaymentMethod: Stripe.PaymentMethod): Promise<Partial<PaymentMethod>> {
    return {
        methodType: PaymentMethodType.ACSS,
        methodTypeFields: {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            fingerPrint: stripePaymentMethod.acss_debit.fingerprint,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            bankName: stripePaymentMethod.acss_debit.bank_name,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            last4: stripePaymentMethod.acss_debit.last4,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            institutionNumber: stripePaymentMethod.acss_debit.institution_number,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            //@ts-ignore - Fix TS FS-3199
            transitNumber: stripePaymentMethod.acss_debit.transit_number,
        } as ACSSPaymentMethod,
    };
}
